import { render } from "./AdminByoMailgun.vue?vue&type=template&id=da3adab8&scoped=true"
import script from "./AdminByoMailgun.vue?vue&type=script&lang=js"
export * from "./AdminByoMailgun.vue?vue&type=script&lang=js"

import "./AdminByoMailgun.vue?vue&type=style&index=0&id=da3adab8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3adab8"]])

export default __exports__